import { LoggerLevel } from '@/constants/logLevel';
import { useLogger } from './useLogger';
import { Environment } from '@/constants/environment';

export function useAppVersionCheck(skipEnvironments: string[] = ['localhost', Environment.Development]): void {
  const versionUrl = '/version.json';
  const storageKey = 'app_version';
  const { log } = useLogger();

  window.addEventListener('focus', async () => {
    try {
      const res = await fetch(versionUrl, { cache: 'no-store' });
      const { version: latestVersion } = await res.json();
      const mode = import.meta.env.MODE;
      const currentVersion = localStorage.getItem(storageKey);
      if ((!currentVersion || currentVersion !== latestVersion) && !skipEnvironments.includes(mode as Environment)) {
        log({
          message: 'New Version found, reloading',
          level: LoggerLevel.DEVELOPMENT,
          type: 'log'
        });
        localStorage.setItem(storageKey, latestVersion);
        window.location.reload();
      }
    } catch (err) {
      log({
        message: err as string,
        level: LoggerLevel.DEVELOPMENT,
        type: 'error'
      });
    }
  });
}
